var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { defaults, getOptions, getRemoteOptions, ServerMode } from "./types";
import { setCustomerSessionId, getYiId, setContext, initLogin, isRenderingForMobileApp, getErrorMessage, startNewSession, isAndroidWebView, setContextAndroidWebView, isiOSWebView, getYiIdMobileWebview, setupWKWebViewJavascriptBridge, setContextiOSWebView, flushClient } from "./util";
var validateOptions = function (opts) {
    if (!opts.ordinaryJsUrl || opts.ordinaryJsUrl == "") {
        throw new Error("URL to load Ordinary from is not specified");
    }
    if (!opts.nonOrdinaryJsUrl || opts.nonOrdinaryJsUrl == "") {
        throw new Error("URL to load NonOrdinary from is not specified");
    }
    if (!opts.e || !(Object.values(ServerMode).includes(opts.e))) {
        throw new Error("Incorrect e found.");
    }
};
var YiInstances = (function () {
    function YiInstances(state) {
        this.state = state;
    }
    YiInstances.prototype.startNewSession = function () {
        if (this.inBrowser) {
            startNewSession();
        }
    };
    YiInstances.prototype.flush = function () {
        flushClient();
    };
    YiInstances.prototype.createYiSession = function (forceRefresh) {
        if (forceRefresh === void 0) { forceRefresh = false; }
        return __awaiter(this, void 0, void 0, function () {
            var yiId;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.getYiId(forceRefresh)];
                    case 1:
                        yiId = _a.sent();
                        if (this.inBrowser) {
                            setCustomerSessionId(yiId);
                        }
                        return [2, yiId];
                }
            });
        });
    };
    YiInstances.prototype.getYiId = function (forceRefresh) {
        if (forceRefresh === void 0) { forceRefresh = false; }
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.inWebView) {
                            return [2, getYiIdMobileWebview()];
                        }
                        if (!this.inBrowser) return [3, 2];
                        if (YiInstances.yiIdCache) {
                            return [2, YiInstances.yiIdCache];
                        }
                        return [4, getYiId(this.state.baseUrl, forceRefresh)];
                    case 1:
                        response = _a.sent();
                        YiInstances.yiIdCache = response.yi;
                        return [2, YiInstances.yiIdCache];
                    case 2: return [2, ''];
                }
            });
        });
    };
    YiInstances.prototype.initLogin = function (yiId, customerId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.inWebView) {
                            return [2];
                        }
                        if (!this.inBrowser) return [3, 2];
                        return [4, initLogin(this.state.baseUrl, yiId, customerId)];
                    case 1:
                        if (_a.sent()) {
                            YiInstances.loginInit = true;
                        }
                        else {
                            YiInstances.loginInit = false;
                        }
                        _a.label = 2;
                    case 2: return [2];
                }
            });
        });
    };
    YiInstances.prototype.setContext = function (contextName, customerId) {
        return __awaiter(this, void 0, void 0, function () {
            var yiId;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.inBrowser) return [3, 4];
                        if (!(customerId != null && !YiInstances.loginInit)) return [3, 3];
                        return [4, this.getYiId()];
                    case 1:
                        yiId = _a.sent();
                        return [4, this.initLogin(yiId, customerId)];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3:
                        setContext(contextName);
                        return [2];
                    case 4:
                        if (this.inAndroidWebView) {
                            setContextAndroidWebView(contextName);
                            return [2];
                        }
                        if (this.iniOSWebView) {
                            setContextiOSWebView(contextName);
                            return [2];
                        }
                        return [2];
                }
            });
        });
    };
    YiInstances.prototype.loadScript = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, firstScript, secondScript;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!this.inBrowser) return [3, 2];
                        return [4, this.appendScript(this.state.ordinaryJsUrl || '')];
                    case 1: return [2, _b.sent()];
                    case 2:
                        if (!this.inAndroidWebView) return [3, 4];
                        return [4, this.appendScript(this.state.nonOrdinaryJsUrl || '')];
                    case 3: return [2, _b.sent()];
                    case 4:
                        if (!this.iniOSWebView) return [3, 6];
                        setupWKWebViewJavascriptBridge(function (bridge) { });
                        return [4, Promise.all([this.appendScript(this.state.nonOrdinaryJsUrl || ''), this.appendScript(this.state.bridgeJsUrl || '')])];
                    case 5:
                        _a = __read.apply(void 0, [_b.sent(), 2]), firstScript = _a[0], secondScript = _a[1];
                        return [2, {
                                loaded: firstScript.loaded && secondScript.loaded,
                                status: "".concat(firstScript.status, ", ").concat(secondScript.status)
                            }];
                    case 6: return [2, {
                            loaded: false,
                            status: 'script loading is disabled.'
                        }];
                }
            });
        });
    };
    YiInstances.prototype.appendScript = function (src) {
        return new Promise(function (resolve) {
            try {
                var script_1 = document.createElement('script');
                script_1.type = 'text/javascript';
                script_1.src = src;
                if (script_1.readyState) {
                    script_1.onreadystatechange = function () {
                        if (script_1.readyState === 'loaded' || script_1.readyState === 'complete') {
                            script_1.onreadystatechange = null;
                            resolve({ loaded: true, status: 'Script loaded' });
                        }
                    };
                }
                else {
                    script_1.onload = function () {
                        resolve({ loaded: true, status: 'Script loaded' });
                    };
                }
                script_1.onerror = function () { return resolve({ loaded: false, status: 'Script failed to load' }); };
                document.getElementsByTagName('head')[0].appendChild(script_1);
            }
            catch (error) {
                resolve({ loaded: false, status: "Script failed to load due to: ".concat(getErrorMessage(error)) });
            }
        });
    };
    Object.defineProperty(YiInstances.prototype, "inBrowser", {
        get: function () {
            return this.state.ordinaryJsEnabled && !isRenderingForMobileApp();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(YiInstances.prototype, "inWebView", {
        get: function () {
            return this.state.nonOrdinaryJsEnabled && isRenderingForMobileApp();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(YiInstances.prototype, "iniOSWebView", {
        get: function () {
            return this.state.nonOrdinaryJsEnabled && isiOSWebView();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(YiInstances.prototype, "inAndroidWebView", {
        get: function () {
            return this.state.nonOrdinaryJsEnabled && isAndroidWebView();
        },
        enumerable: false,
        configurable: true
    });
    YiInstances.loginInit = false;
    return YiInstances;
}());
var createYi = function (o) {
    var opts = Object.assign({ baseUrl: '' }, defaults, o);
    validateOptions(opts);
    return new YiInstances(opts);
};
export { getOptions, getRemoteOptions, ServerMode };
export default createYi;
